import { format } from "date-fns"
import { Calendar as CalendarIcon } from "lucide-react"
import { useState } from "react"
import { cn } from "../../../utils/helper"
import { Button } from "../Button"
import { Calendar } from "../Calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../Popover"
import { DayNotes, notedDayClassNames, notedDayContent, unavailableDays } from "./dayNotes"

interface DatePickerProps {
  initialDate?: Date
  setNewDate: (date: Date) => void
  // Free spaces under each day, and a line above the calendar saying what they're for.
  dayNotes?: DayNotes
  caption?: string
  onMonthChange?: (month: Date) => void
  // The month shown, when the caller keeps it (so free spaces stay in step with it).
  month?: Date
}
 
export function DatePicker({
  initialDate,
  setNewDate,
  dayNotes,
  caption,
  onMonthChange,
  month,
 }: DatePickerProps) {
  const [date, setDate] = useState<Date>();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={cn(
            "w-[280px] justify-start text-left font-medium text-sm h-12 px-4 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-100",
            !date && "text-muted-foreground"
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {date ? format(date, "PPP") : initialDate ? format(initialDate, "PPP") : <span className="text-secondaryText">Select Booking Date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        {caption && <p className="border-b border-gray-200 px-4 py-2 text-xs text-gray-600">{caption}</p>}
        <Calendar
          mode="single"
          className="bg-gray-50"
          selected={date ?? initialDate}
          defaultMonth={date ?? initialDate}
          onMonthChange={onMonthChange}
          {...(month ? { month } : {})}
          disabled={unavailableDays(dayNotes)}
          {...(dayNotes ? { classNames: notedDayClassNames, components: { DayContent: notedDayContent(dayNotes) } } : {})}
          onSelect= {
            (newDate) => {
              setDate(newDate);
              setNewDate(newDate!);
            }
          }
          initialFocus
        />
      </PopoverContent>
    </Popover>
  )
}